import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "constants/constants";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  paper: {
    width: "100%",
    height: "100%",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    boxShadow: "none",
    borderRadius: 15,
    borderBottom: "#e8e9ee 2px solid",
  },
  tableCell: {
    cursor: "default",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  tableHeadCell: {
    background: Colors.WHITE,
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: 15,
    borderBottom: "#e8e9ee 2px solid",
  },
  topContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start"
  },
  buttonBox: {
    margin: "32px 24px",
    display: "flex",
    gap: 15,
    justifyContent: "center",
  },
  dateBox: {
    border: "3px solid white",
    transition: "0.2s",
    cursor: "pointer",
    color: "black",
    background: Colors.GRAY,
    width: "25%",
    textAlign: "center",
    padding: theme.spacing(3, 0.5),
    borderRadius: 16,
    textWrap: "nowrap",
    boxSizing: "border-box",
  },
  activeDateBox: {
    background: "#C6F7D2",
    color: Colors.GREEN,
    border: "3px solid #a4cb80",
  },
  disabled: {
    pointer: "none",
    pointerEvents: "none",
    opacity: 0.5,
  },
  editButton: {
    "&:hover, &.Mui-focusVisible": { backgroundColor: "#bddfff" },
    backgroundColor: "#e2f1ff",
    borderRadius: "5px",
  },
  alertColor: {
    background: "#C6F7D2",
  },
  warningColor: {
    background: "#f5f7c6"
  },
  "@media (max-width: 1050px)": {
    buttonBox: {
      flexDirection: "column",
      margin: "32px 0",
    },
    dateBox: {
      width: "100%",
      padding: theme.spacing(3, 0.5),
    },
  },
  "@media (max-width: 700px)": {
    gridContainer: {
      display: "block",
    },
    topContent: {
      flexDirection: "column-reverse",
      gap: 10,
  },
  },
}));
